// src/components/HeatmapControlPanel.js - ПАНЕЛЬ УПРАВЛЕНИЯ HEATMAP
import React, { useState, useEffect } from 'react';
import mapiService from '../services/mapiService';

function HeatmapControlPanel({ heatmapLayer, onSettingsChange, currentSettings }) {
  const [datasets, setDatasets] = useState([]);
  const [availableProperties, setAvailableProperties] = useState(['students', 'teachers']);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadAvailableDatasets();
  }, []);

  const loadAvailableDatasets = async () => {
    try {
      const availableDatasets = await mapiService.getAvailableDatasets();
      setDatasets(availableDatasets);
    } catch (error) {
      console.error('Failed to load datasets:', error);
    }
  };

  const handleToggle = async () => {
    setIsLoading(true);
    try {
      await heatmapLayer.toggle(!currentSettings.enabled);
      onSettingsChange({ enabled: !currentSettings.enabled });
    } catch (error) {
      console.error('Failed to toggle heatmap:', error);
    }
    setIsLoading(false);
  };

  const handleDatasetChange = async (datasetId) => {
    setIsLoading(true);
    try {
      await heatmapLayer.changeDataset(datasetId);
      onSettingsChange({ dataset: datasetId });
    } catch (error) {
      console.error('Failed to change dataset:', error);
    }
    setIsLoading(false);
  };

  const handlePropertyChange = (propertyField) => {
    heatmapLayer.changeProperty(propertyField);
    onSettingsChange({ propertyField: propertyField });
  };

  const stats = heatmapLayer?.getStats() || {};

  return (
    <div className="heatmap-control-panel">
      {/* Заголовок панели */}
      <div className="panel-header" onClick={() => setIsCollapsed(!isCollapsed)}>
        <div className="panel-title">
          🌡️ Heatmap Controls
          {currentSettings.enabled && (
            <span className="status-indicator active"></span>
          )}
        </div>
        <button className="collapse-btn">
          {isCollapsed ? '▼' : '▲'}
        </button>
      </div>

      {/* Основное содержимое */}
      {!isCollapsed && (
        <div className="panel-content">
          {/* Основной переключатель */}
          <div className="control-group">
            <label className="control-label">Enable Heatmap</label>
            <button 
              className={`toggle-btn ${currentSettings.enabled ? 'active' : ''}`}
              onClick={handleToggle}
              disabled={isLoading}
            >
              {isLoading ? '⏳' : currentSettings.enabled ? '✅ ON' : '❌ OFF'}
            </button>
          </div>

          {/* Выбор dataset */}
          {currentSettings.enabled && (
            <>
              <div className="control-group">
                <label className="control-label">Dataset</label>
                <select 
                  value={currentSettings.dataset || 'schools'}
                  onChange={(e) => handleDatasetChange(e.target.value)}
                  disabled={isLoading}
                  className="control-select"
                >
                  {datasets.map(dataset => (
                    <option key={dataset.id} value={dataset.id}>
                      {dataset.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Выбор свойства для визуализации */}
              <div className="control-group">
                <label className="control-label">Property Field</label>
                <select 
                  value={currentSettings.propertyField || 'students'}
                  onChange={(e) => handlePropertyChange(e.target.value)}
                  className="control-select"
                >
                  {availableProperties.map(prop => (
                    <option key={prop} value={prop}>
                      {prop.charAt(0).toUpperCase() + prop.slice(1)}
                    </option>
                  ))}
                </select>
              </div>

              {/* Статистика */}
              <div className="stats-section">
                <h4>📊 Statistics</h4>
                <div className="stats-grid">
                  <div className="stat-item">
                    <span className="stat-label">Features:</span>
                    <span className="stat-value">{stats.featuresCount?.toLocaleString() || '0'}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">Dataset:</span>
                    <span className="stat-value">{stats.dataset || 'None'}</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-label">Property:</span>
                    <span className="stat-value">{stats.propertyField || 'None'}</span>
                  </div>
                </div>
              </div>

              {/* Инструкции */}
              <div className="instructions">
                <h4>💡 Instructions</h4>
                <ul>
                  <li>🔍 Zoom out to see the heatmap</li>
                  <li>🔍 Zoom in to see individual points</li>
                  <li>👆 Click on points for details</li>
                  <li>🌈 Colors indicate data density</li>
                </ul>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default HeatmapControlPanel;